// @flow
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {CommaFormat} from '../../../../../elements/Price/Price';
import {Default, Mobile} from '../../../../../utils/responsive';
import AddressForm from '../../../../../elements/AddressForm/AddressForm';
import {FormattedMessage} from 'react-intl';
import defaultPic from "../../../../../assets/img/profileplaceholder.jpg";

import style from './CourierInfo.scss';
import icons from "../../../../../assets/styles/icons.scss";

import type {LocalValuesState} from '../../../../local-values/duck';
import type {Courier, User} from '../../../../../entities';

type Props = {|
  +localValues: LocalValuesState;
  +courier: Courier;
  +days?: number;
  +servicesCost: number;
  +user?: User;
|};

export default class CourierInfo extends Component<Props> {

  render() {
    const {localValues, courier, days, servicesCost, user} = this.props;
    let subtitle = days && (
      <FormattedMessage id="newOrder.quote.diy.shipping.days">{
        txt => <p className={style.shippingDays}>{days}-{days + 3} {txt}</p>
      }</FormattedMessage>);
    /*if (courier.id !== "CR09043495") {
      subtitle = (
        <FormattedMessage id="newOrder.quote.diy.specialShipping">{
          txt => <p className={style.shippingDays}>{txt}</p>
        }</FormattedMessage>);
    }*/
    return (
      <div className={style.chosenCourierWrap}>
        <div className={style.courierInfoWrap}>
          <img src={courier.image || defaultPic}
               alt="courier"/>
          <div className={style.textWrap}>
            <p className={style.courierName}>{courier.name}</p>
            <p className={style.price}>$ <CommaFormat price={servicesCost}/></p>
            {/*<Default>
              {subtitle}
            </Default>*/}
          </div>
        </div>
        {/*<Mobile>
          {subtitle}
        </Mobile>*/}
        <hr/>
        <AddressForm readOnly
                     type="courier"
                     localValues={localValues}
                     handleChange={_ => undefined}
                     handleChangePhone={_ => undefined}
                     handleFocus={_ => undefined}
                     handleChangeAdmin1={_ => undefined}
                     handleChangeAdmin2={_ => undefined}
                     handleChangeAdmin3={_ => undefined}
                     handlePhoneInit={_ => undefined}
                     country={{value: courier.address.country.code}}
                     admin1={{
                       value: `${courier.address.admin1.id}`,
                       label: courier.address.admin1.name,
                     }}
                     admin1Items={[]}
                     isLoadingAdmin1={false}
                     admin2={{
                       value: `${courier.address.admin2.id}`,
                       label: courier.address.admin2.name,
                     }}
                     admin2Items={[]}
                     isLoadingAdmin2={false}
                     admin3={{
                       value: '',
                       label: '',
                     }}
                     admin3Items={[]}
                     isLoadingAdmin3={false}
                     address1={{
                       value: courier.address.address1,
                     }}
                     address2={{
                       value: courier.address.address2,
                     }}
                     name={{
                       value: user ? `${user.firstName} - Qempo` : '',
                     }}
                     phone={{
                       value: courier.address.phone,
                     }}
                     zipCode={{
                       value: courier.address.zipCode,
                     }}/>
        <div className={style.infoWrap}>
          <i className={icons.symbolCheck}/>
          {courier.address.address2 ?
            (
              <span>No olvides colocar la información de “Dirección 2” para que tu pedido llegue al destino indicado.</span>
            ) :
            (
              <span>No olvides colocar la información exacta mostrada para que tu pedido llegue al destino indicado.</span>
            )
          }
        </div>
      </div>);
  }
}

CourierInfo.propTypes = {
  localValues: PropTypes.object.isRequired,
  courier: PropTypes.object.isRequired,
  days: PropTypes.number,
  servicesCost: PropTypes.number.isRequired,
  user: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/modules/order/Purchase/components/CourierInfo/CourierInfo.jsx